export function setLocale(key) {
  return {
    type: '@locale/SET_KEY',
    payload: { key },
  }
}
